import { useEffect, useState } from 'react';
import { webCrmApi } from '../axiosApi';

export function useOnayBilimStatus(
    id,
    onActive = () => { },
    onInactive = () => { }
) {
    const [active, setActive] = useState(false);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const resp = await webCrmApi.get(`integrations/onay/users/status/${id}`);
                const isActive = resp.data?.data?.active || false;
                setActive(isActive);
                if (isActive) {
                    onActive();
                } else {
                    onInactive();
                }
            } catch (e) {
                console.error(e);
            }
        };

        if (id) fetchStatus();
    }, [id]);

    return active;
}